import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import moment from 'moment';
import LoyaltyContext from './LoyaltyContext';
import ModalContext from '../modal/ModalContext';
import LoadingPage from '../LoadingPage';

const Offer = ({ offerId }) => {
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState({});
  const { fetchOffer } = useContext(LoyaltyContext);
  const { setTitle } = useContext(ModalContext);

  const getOffer = () => {
    setLoading(true);
    fetchOffer(offerId).then(response => {
      if (setTitle) {
        setTitle(response.data.Title || 'Offer Details');
      }

      setDetails(response.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    getOffer();
  }, []);

  if (loading) {
    return <LoadingPage message="Fetching Offer" style={{ height: '480px' }} />;
  }

  const hasParts = () => {
    if (!details.PartNumbers.length) {
      return false;
    }

    if (details.PartNumbers.length === 1) {
      if (details.PartNumbers[0] === '') {
        return false;
      }
    }

    return true;
  };

  const offerDetails = () => {
    let full = '';

    if (details.Description) {
      full = details.Description;
    }

    if (details.Detail) {
      const detail = /^off\s/.test(details.Detail) ? `${details.Amount} ${details.Detail}` : details.Detail;
      if (full) {
        full += ` ${detail}`;
      } else {
        full = detail;
      }
    }

    return full;
  };

  const fullDetail = offerDetails();

  return (
    <div className="loyalty-offer">
      <div className="detail id">
        <div className="caption">Unique Offer ID</div>
        <div className="value">
          {details.OfferUniqueId}
        </div>
      </div>
      {fullDetail !== '' && (
        <Col md={12} className="details">
          {fullDetail}
        </Col>
      )}
      <Col sm={6} md={6} className="preview">
        <div className="image">
          <img src={details.ImageUrl} alt="Offer Preview" />
        </div>
      </Col>
      <Col sm={6} md={6} className="campaign">
        <div className="detail blue">
          <div className="caption">Coupon Code</div>
          <div className="value">{details.CouponCode}</div>
        </div>

        <div className="detail">
          <div className="caption">Print &amp; Campaign Code</div>
          <div className="value">
            {details.PrintCode} <span>&amp;</span> {details.CampaignCode}
          </div>
        </div>

        <div className="detail">
          <div className="caption">Start - End</div>
          <div className="value">
            {moment(details.StartDate).format('MM/DD/YYYY')} - {moment(details.EndDate).format('MM/DD/YYYY')}
          </div>
        </div>
      </Col>

      <div className="clearfix" />

      <div className="more">
        <Col sm={6} md={6} className="detail">
          <div className="caption">Offer Category</div>
          <div className="value">{details.OfferCategory}</div>
        </Col>
        <Col sm={6} md={6} className="detail">
          <div className="caption">Offer Type</div>
          <div className="value">{details.OfferType}</div>
        </Col>
        <Col sm={6} md={6} className="detail">
          <div className="caption">Amount Type</div>
          <div className="value">{details.AmountType}</div>
        </Col>
        <Col sm={6} md={6} className="detail green">
          <div className="caption">Amount</div>
          <div className="value">
            {details.Amount} {details.Currency}
          </div>
        </Col>
        <div className="clearfix" />
      </div>

      {hasParts() && (
        <div className="parts">
          <div className="caption">Parts</div>
          <div className="value">
            {details.PartNumbers.map(part => {
              return (
                <div className="part" key={part}>
                  {part}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

Offer.propTypes = {
  offerId: PropTypes.string,
};

export default Offer;
